import CustomButton from './CustomButton.vue';

export default CustomButton;
